export const TextEditorItalic = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6.22206 1.77783V3.55561H8.51539L5.26206 10.6667H2.6665V12.4445H9.77762V10.6667H7.48428L10.7376 3.55561H13.3332V1.77783H6.22206Z'
      fill='#334155'
    />
  </svg>
);
